{
  "title": "Searing Smite",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "V",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "The next time you hit a creature with a melee weapon attack during the spell’s duration, your weapon flares with white-hot intensity, and the attack deals an extra 1d6 fire damage to the target and causes the target to ignite in flames.",
    "At the start of each of its turns until the spell ends, the target must make a Constitution saving throw. On a failed save, it takes 1d6 fire damage. On a successful save, the spells ends. If the target or a creature within 5 feet of it uses an action to put out the flames, or if some other effect douses the flames (such as the target being submerged in water), the spell ends.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the initial extra damage dealt by the attack increases by 1d6 for each slot above 1st."
  ],
  "spellLists": ["paladin", "ranger"]
}
